import { render, staticRenderFns } from "./RecipientFilter.vue?vue&type=template&id=04e08bfb"
import script from "./RecipientFilter.vue?vue&type=script&lang=js"
export * from "./RecipientFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports